import Alert from "../../../utils/alert";
import Assert from "../../../utils/asserts";
import CollectionUtils from "../../../utils/collections";
import { serverToLocalDate } from "../../../utils/dateTimeUtils";
import EmptyLogTable from "./components/emptyTable";
import LogTable from "./components/logTable";
import TotalTable from "./components/totalTable";

function mapLogsToDate(logs) {
    const dateTologs = []

    for (const log of logs) {
        const start = serverToLocalDate(log.start);
        if (!dateTologs[start]) {
            dateTologs[start] = []
        }
        dateTologs[start].push(log)
    }

    return dateTologs
}

export function getTableModel(logs) {
    const userIds = Array.from(new Set(logs.map((l) => l.user.id)))
    userIds.sort((a,b) =>  a - b)
    
    const dateTologs = mapLogsToDate(logs)

    const rows = []
    const logTotalsMap = {}

    for (const userId of userIds) {
        logTotalsMap[userId] = {
            duration: 0,
            clicks: 0,
            keystrokes: 0,
            startToEnd: 0
        }
    }

    const mergedSessions = new Set()

    let totalClicks = 0
    let totalKeystrokes = 0
    let middleDuration = 0

    for (const [date, logs] of Object.entries(dateTologs)) {
        const userIdToLog = CollectionUtils.arrToMap(logs, l => l.user.id, (a, b) => {

            a.error = a.error || !(a.end < b.start || b.end < a.start)
            a.warn = a.error ? false : true

            let inactivityDurationMs

            if (a.end < b.start) {
                inactivityDurationMs = b.start - a.end
            } else if (b.end < a.start) {
                Assert.positiveNumber(a.start - b.end, "test")
                inactivityDurationMs = a.start - b.end
            }
            a.inactivityDurationMs = inactivityDurationMs

            a.duration += b.duration
            a.clicks += b.clicks
            a.keystrokes += b.keystrokes
            a.middleDuration += b.middleDuration
            a.longDuration += b.longDuration
            a.start = a.start > b.start ? b.start : a.start
            a.end = a.end > b.end ? a.end : b.end

            return a
        })

        const cells = [date]

        for (const userId of userIds) {
            const log = userIdToLog[userId]

            if (log) {
                cells.push(<LogTable {...log} />)
                const total = logTotalsMap[userId]
                total.duration += (log.duration - (log.inactivityDuration === undefined ? 0 : log.inactivityDuration))
                middleDuration += (log.middleDuration - (log.inactivityDuration === undefined ? 0 : log.inactivityDuration))
                total.middleDuration += (log.middleDuration - (log.inactivityDuration === undefined ? 0 : log.inactivityDuration))
                total.longDuration += (log.longDuration - (log.inactivityDuration === undefined ? 0 : log.inactivityDuration))
                totalClicks += log.clicks
                total.clicks += log.clicks
                total.keystrokes += log.keystrokes
                totalKeystrokes += log.keystrokes
                total.startToEnd += log.end - log.start
            } else {
                cells.push(<EmptyLogTable />)
            }
        }

        rows.push(cells)
    }

    if (mergedSessions.size > 0) {
        Alert.warn("Merge of multiple user sessons for same date. Users:" + Array.from(mergedSessions))
    }

    const totals = ["TOTAL"]

    for (const userId of userIds) {
        totals.push(<TotalTable {...logTotalsMap[userId]} />)
    }

    rows.push(totals)

    return { rows, totalClicks, totalKeystrokes, middleDuration, userIds }
}

export function msToHour(ms) {
    return secToHour(Math.abs(ms) / 1000)
}

export function minToHour(min) {
    let minutes = min % 60 + ""
    if (minutes.length == 1) {
        minutes = 0 + minutes
    }
    return (Math.floor(min / 60)) + "." + minutes
}

function secToHour(sec) {
    return minToHour(Math.floor(sec / 60))
}